declare namespace $ {

	type $mol_grid__records_mol_grid_demo_1 = $mol_type_enforce<
		ReturnType< $mol_grid_demo['records'] >
		,
		ReturnType< $mol_grid['records'] >
	>
	type $mol_grid__col_head_content_mol_grid_demo_2 = $mol_type_enforce<
		ReturnType< $mol_grid_demo['col_head_content'] >
		,
		ReturnType< $mol_grid['col_head_content'] >
	>
	export class $mol_grid_demo extends $mol_example_large {
		records( ): Record<string, any>
		col_head_content( id: any): readonly(any)[]
		Grid( ): $mol_grid
		title( ): string
		rows( ): number
		cols( ): number
		sub( ): readonly(any)[]
		tags( ): readonly(any)[]
		aspects( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map